var _path, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "300px",
    height: "222px",
    viewBox: "0 0 300 222",
    enableBackground: "new 0 0 300 222",
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M300,132.373v50.637c0,3.531-2.978,6.428-6.643,6.428H6.63c-3.658,0-6.63-2.896-6.63-6.428V75.881l44.531,3.012l-1.175,1.65 l-17.489,24.497c-3.707,4.048,0.779,3.959,0.779,3.959h24.694l-10.535,56.988c0.954,4.574,4.486,0,4.486,0l52.679-73.386 c2.412-3.291-0.691-3.028-0.691-3.028L72.497,89.4l8.808-56.046c0.164-6.394-3.631-0.866-3.631-0.866L44.531,78.894l-0.254,0.355 L0,78.187V6.428C0,2.896,2.972,0,6.63,0h286.728C297.022,0,300,2.896,300,6.428v40.838l-27.289-1.258v-7.281 c0-2.796-2.873-5.078-6.416-5.078H157.351c-3.537,0-6.406,2.281-6.406,5.078v19.238c0,2.797,2.869,5.067,6.406,5.067h108.944 c3.543,0,6.416-2.27,6.416-5.067V45.031L300,45.451v57.576l-35.359-2.793v-2.65c0-2.415-2.973-4.344-6.644-4.344H156.633 c-3.663,0-6.63,1.93-6.63,4.344v3.092c0,2.435,2.967,4.366,6.63,4.366h101.364c3.671,0,6.644-1.931,6.644-4.366v-0.723L300,100.93 v32.701l-35.359-2.795v-2.707c0-2.414-2.973-4.344-6.644-4.344H156.633c-3.663,0-6.63,1.93-6.63,4.344v3.092 c0,2.436,2.967,4.365,6.63,4.365h101.364c3.671,0,6.644-1.93,6.644-4.365v-0.803L300,132.373z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "0.13,222.021 0.13,204.795 69.173,204.795 42.784,222.021 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "300.13,222.021 300.13,204.795 230.916,204.795 257.368,222.021 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerator);
export default __webpack_public_path__ + "static/media/generator.6864d188c3fadc5e00d90dcda2f86942.svg";
export { ForwardRef as ReactComponent };